// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Sp-z","tupacHeader":"Tp-z","tupacHeader2":"Up-z","tupacMenu":"Vp-z","tupacMenu2":"Wp-z","tupacMain":"Xp-z","tupacMain2":"Yp-z"};